import { defineMessages } from "react-intl";

const messages = defineMessages({
  interestedButtonLabel: {
    id: "emailsNotSupported.interestedButtonLabel",
    defaultMessage: "I’m Interested",
    description: "Interested action of not supported page",
  },
  interestedDescription: {
    id: "emailsNotSupported.interestedDescription",
    defaultMessage: "Tap “I’m interested” and we’ll have your account manager reach out.",
    description: "Interested description of not supported page",
  },
  interestedDescriptionNotOwner: {
    id: "emailsNotSupported.interestedDescriptionNotOwner",
    defaultMessage: "Let your manager or administrator know you’d like to use MMC Emails!",
    description: "Interested description of not supported page fot not owners",
  },
  point1: {
    id: "emailsNotSupported.point1",
    defaultMessage: "Send emails to companies and people in MMC",
    description: "Point 1 of not supported page",
  },
  point2: {
    id: "emailsNotSupported.point2",
    defaultMessage: "Track opens and clicks",
    description: "Point 2 of not supported page",
  },
  point3: {
    id: "emailsNotSupported.point3",
    defaultMessage: "Bulk send individual emails",
    description: "Point 3 of not supported page",
  },
  point4: {
    id: "emailsNotSupported.point4",
    defaultMessage: "Auto-generate email activities upon send",
    description: "Point 4 of not supported page",
  },
  title: {
    id: "emailsNotSupported.title",
    defaultMessage: "Send and track emails in MMC",
    description: "Title of not supported page",
  },
});

export default messages;
